<template>
    <div>
        <div class="product-family__finishes">
            <div class="product-family__finishes-col-1">
                <div class="product-family__finish-label">Selected Finish:</div>
                <div class="product-family__finish-name">{{ activeFinish.displayName || activeFinish.title }}</div>
            </div>
            <div class="product-family__finishes-col-2">
                <div class="product-family__slider-wrap" ref="pfSwiperParent">
                    <div class="product-family__slider swiper js-product-family-slider" ref="pfSwiperInstance">
                        <div class="swiper-wrapper">
                            <div v-for="finish in finishes" :key="finish?.title" class="swiper-slide product-family__finishes-item">
                                <a
                                    :href="null"
                                    @click="(e) => $emit('filterChange', finish, portfolio, style, e)"
                                    v-bind:class="['product-family__finishes-link', 'js-tooltip', isActiveFinish(finish) && 'product-family__finishes-link--active']"
                                    :title="finish.displayName || finish?.title"
                                >
                                    <img :src="finishThumb(finish.thumbnail)" class="product-family__finishes-img" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-button-next product-family__arrow-right" ref="rightArrow"></div>
                    <div class="swiper-button-prev product-family__arrow-left" ref="leftArrow"></div>
                </div>
            </div>
        </div>
        <div class="product-family__portfolio">
            <div class="section-large">
                <div class="d-flex justify-content-center align-items-stretch flex-column flex-md-row">
                    <div class="mx-3">
                        <label for="portfolioSelection" class="d-block form-check-label">Filter By Portfolio</label>
                        <div class="d-block">
                            <div class="d-block">
                                <select name="portfolioSelection" id="portfolioSelection" v-model="portfolio" @change="changedFilter" class="form-control">
                                    <option value="">Select Portfolio Type</option>
                                    <option v-for="port in portfolios" :value="port?.title" :selected="portfolio === port?.title">{{ port?.title }}</option>
                                </select>
                            </div>
                            <div class="d-block py-1" v-if="portfolio">
                                <a @click="resetPortfolioFilter" href="#">
                                    <span v-if="portfolio"><strong class="text-red">X</strong> Unset {{ portfolio }} Portfolio Filter</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="mx-3">
                        <label for="portfolioSelection" class="d-block form-check-label mt-4 mt-md-0">Filter By Style</label>
                        <div class="d-block">
                            <div class="d-block">
                                <select name="styleSelection" id="styleSelection" v-model="style" @change="changedFilter" class="form-control">
                                    <option value="">Select Style</option>
                                    <option v-for="styleOption in styles" :value="styleOption?.title" :selected="style === styleOption?.title">{{ styleOption?.title }}</option>
                                </select>
                            </div>
                            <div class="d-block py-1" v-if="style">
                                <a @click="resetStyleFilter" href="#">
                                    <span v-if="style"><strong class="text-red">X</strong> Unset {{ style }} Filter</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Tooltips } from 'Modules/tooltips';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export default {
    name: 'ProductFamilyFinishes',
    props: {
        finishes: {
            type: Array,
            default: () => [] as any[],
        },
        portfolios: {
            type: Array,
            default: () => [] as any[],
        },
        styles: {
            type: Array,
            default: () => [] as any[],
        },
        activeFinish: {
            type: Object,
            default: {} as any,
        },
    },
    data() {
        return {
            portfolio: '',
            style: '',
        };
    },
    methods: {
        isActiveFinish(finish) {
            return finish.title === this.activeFinish.title;
        },
        //if it comes through null set it do the default no image in sitefinity
        finishThumb(finish) {
            return finish ? finish : 'https://images.baldwinhardware.com/is/image/Baldwin/bw_5023-056-pass-cr1';
        },
        changedFilter() {
            this.$emit('filterChange', this.activeFinish, this.portfolio, this.style);
        },
        resetPortfolioFilter(event) {
            event.preventDefault();
            this.portfolio = '';
            this.$emit('filterChange', this.activeFinish, this.portfolio, this.style);
        },
        resetStyleFilter(event) {
            event.preventDefault();
            this.style = '';
            this.$emit('filterChange', this.activeFinish, this.portfolio, this.style);
        },
        setupRotator() {
            //setup each swiper instance
            let swiper: any = new Swiper(`.js-product-family-slider`, {
                slidesPerView: 'auto',
                slidesPerGroup: 2,
                spaceBetween: 5,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: this.$refs.leftArrow,
                    prevEl: this.$refs.rightArrow,
                },
                on: {
                    init: function () {},
                },
            });

            swiper.init();
        },
    },
    created() {
        //set the default active state from params if available if not set it to the first item in the finishes list

        let params = new URLSearchParams(window.location.search);

        if (params.has('finish') || params.has('portfolio') || params.has('style')) {
            let finishesValueToEmit = '';
            let portfolioValueToEmit = '';
            let styleValueToEmit = '';

            if (params.has('finish')) {
                finishesValueToEmit = this.finishes.filter((e) => e.title === decodeURIComponent(params.get('finish')))[0];
            } else {
                finishesValueToEmit = this.finishes[0];
            }

            if (params.has('portfolio')) {
                this.portfolio = params.get('portfolio');
                portfolioValueToEmit = decodeURIComponent(params.get('portfolio'));
            } else {
                portfolioValueToEmit = this.portfolio;
            }

            if (params.has('style')) {
                this.style = params.get('style');
                styleValueToEmit = decodeURIComponent(params.get('style'));
            } else {
                styleValueToEmit = this.style;
            }

            this.$emit('filterChange', finishesValueToEmit, portfolioValueToEmit, styleValueToEmit);
        } else if (!this.activeFinish.displayName) {
            this.$emit('filterChange', this.finishes[0], this.portfolio, this.style);
        }
    },
    mounted() {
        this.setupRotator();
        Tooltips.init();
    },
};
</script>
